<template>
  <div class="dashboard-container">
    <!-- 顶部导航栏 -->
    <div class="header">
      <div class="header-left">
        <img src="../assets/logo_admin.png" alt="Logo" class="logo">
        <span class="system-title">后台管理系统</span>
      </div>
      <div class="header-right">
        <el-dropdown @command="handleCommand">
          <span class="user-info">
            <el-avatar :size="32" :src="userInfo.avatar || ''">
              {{ userInfo.admin_name ? userInfo.admin_name.charAt(0) : 'A' }}
            </el-avatar>
            <span class="username">{{ userInfo.admin_name || '管理员' }}</span>
            <i class="el-icon-arrow-down"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="profile">
              <i class="el-icon-user"></i> 个人中心
            </el-dropdown-item>
            <el-dropdown-item command="settings">
              <i class="el-icon-setting"></i> 设置
            </el-dropdown-item>
            <el-dropdown-item divided command="logout">
              <i class="el-icon-switch-button"></i> 退出登录
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <!-- 主体内容区域 -->
    <div class="main-content">
      <!-- 左侧菜单栏 -->
      <div class="sidebar">
        <sidebar-menu :menus="menuItems" />
      </div>

      <!-- 右侧内容区域 -->
      <div class="content">
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
import { logout } from '../api/auth'
import SidebarMenu from '../components/SidebarMenu.vue'

export default {
  name: 'Dashboard',
  components: {
    SidebarMenu
  },
  data() {
    return {
      userInfo: {},
      activeMenu: '/dashboard'
    }
  },
  created() {
    // 获取用户信息
    this.getUserInfo()
    // 设置当前激活的菜单
    this.activeMenu = this.$route.path
  },
  computed: {
    // 获取菜单项，根据路由配置生成
    menuItems() {
      // 找到dashboard路由的子路由
      const dashboardRoute = this.$router.options.routes.find(route => route.path === '/dashboard');
      if (dashboardRoute && dashboardRoute.children) {
        // 过滤掉不需要在菜单中显示的路由（如重定向）
        return dashboardRoute.children.filter(child => 
          child.meta && child.meta.hidden === false
        ).map(child => {
          // 为每个菜单项生成完整的路径
          const menuItem = {
            ...child,
            path: child.path,
            fullPath: `/dashboard/${child.path}`,
            title: child.meta.title,
            icon: child.meta.icon || 'el-icon-document'
          };
          
          if (child.children) {
            // 如果有子菜单，为子菜单项生成完整路径
            menuItem.children = child.children.map(subChild => ({
              ...subChild,
              path: subChild.path,
              fullPath: `/dashboard/${child.path}/${subChild.path}`,
              title: subChild.meta.title,
              icon: subChild.meta.icon || 'el-icon-document'
            }));
          }
          
          return menuItem;
        });
      }
      return [];
    }
  },
  methods: {
    getUserInfo() {
      const userInfoStr = localStorage.getItem('userInfo')
      if (userInfoStr) {
        this.userInfo = JSON.parse(userInfoStr)
      }
    },
    
    handleCommand(command) {
      switch (command) {
        case 'profile':
          this.$router.push('/dashboard/profile')
          break
        case 'settings':
          this.$router.push('/dashboard/settings')
          break
        case 'logout':
          this.handleLogout()
          break
      }
    },
    
    async handleLogout() {
      try {
        await this.$confirm('确定要退出登录吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        // 调用退出登录接口
        await logout()
        
        // 清除本地存储
        localStorage.removeItem('token')
        localStorage.removeItem('userInfo')
        
        this.$message.success('退出登录成功')
        
        // 跳转到登录页
        this.$router.push('/login')
      } catch (error) {
        if (error !== 'cancel') {
          console.error('退出登录失败:', error)
          this.$message.error('退出登录失败')
        }
      }
    }
  }
}
</script>

<style scoped>
.dashboard-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

/* 顶部导航栏样式 */
.header {
  height: 60px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  position: relative;
  z-index: 1001;
}

.header-left {
  display: flex;
  align-items: center;
}

.logo {
  height: 32px;
  width: 32px;
  margin-right: 12px;
}

.system-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.header-right {
  display: flex;
  align-items: center;
}

.user-info {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.user-info:hover {
  background-color: #f5f7fa;
}

.username {
  margin: 0 8px;
  font-size: 14px;
  color: #333;
}

/* 主体内容区域样式 */
.main-content {
  flex: 1;
  display: flex;
  overflow: hidden;
}

/* 左侧菜单栏样式 */
.sidebar {
  width: 200px;
  background: #304156;
  overflow-y: auto;
  flex-shrink: 0;
}

.sidebar-menu {
  border: none;
}

.sidebar-menu .el-menu-item {
  height: 50px;
  line-height: 50px;
}

.sidebar-menu .el-submenu .el-menu-item {
  height: 45px;
  line-height: 45px;
  padding-left: 50px !important;
}

/* 右侧内容区域样式 */
.content {
  flex: 1;
  background: #f0f2f5;
  overflow-y: auto;
  padding: 20px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .sidebar {
    width: 64px;
  }
  
  .sidebar-menu .el-menu-item span,
  .sidebar-menu .el-submenu span {
    display: none;
  }
  
  .system-title {
    display: none;
  }
}
</style>